import { render, staticRenderFns } from "./systemmessage.vue?vue&type=template&id=21e6cef5&"
import script from "./systemmessage.vue?vue&type=script&lang=js&"
export * from "./systemmessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports